import {
  Yes,
  errorNotePrequalificationField,
  prequalificationField,
  prequalificationSection
} from '../../utils/constant';
import { getFieldValue } from '../utils';

const prequalificationSectionHelpers = ({ fieldName, formFields }) => {
  if (
    fieldName === prequalificationSection ||
    fieldName === errorNotePrequalificationField
  ) {
    const prequalificationFieldsValue = prequalificationField.map(value => {
      return getFieldValue(value, formFields) === Yes;
    });
    if (
      fieldName === errorNotePrequalificationField &&
      !prequalificationFieldsValue.includes(true)
    ) {
      return true;
    }
  }
};

export default prequalificationSectionHelpers;
